import classNames from 'classnames';
import * as mobxReact from 'mobx-react';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { CommonModal } from '../../../../global/modal/common/common-modal';
import Text from '../../../../global/text/text';
import './select-report-popover.scss';

export interface ISelectReportTypeModalProps extends IBodyProps {
    intl: IntlShape;
    titlePopover: string;
    popoverIsOpen: boolean;
}

interface IBodyProps {
    closePopover: () => void;
    registrationReports;
    postEventReports;
}

const ModalBody =
    mobxReact.observer((props: IBodyProps) => {
        const {
            closePopover,
            registrationReports,
            postEventReports
        } = props;

        const tileAction = (action: () => void) => {
            action();
            closePopover();
        };

        const columnsView = (registrationReports.length && postEventReports.length)
            ? 'justify-content-evenly'
            : 'justify-content-center';

        return (
            <form className='select-report-popover-body'>
                <div className={classNames(columnsView, 'oe-form_body flex')}>
                    {!!registrationReports.length && <div className='flex select-report-popover-body__reports column'>
                        <Text message='Registration Reports' className='flex select-report-popover-body__title' />
                        {registrationReports.map(reportTile => {
                            return (
                                <button
                                    key={reportTile.label}
                                    className='flex select-report-popover-body__tile'
                                    onClick={() => tileAction(reportTile.action)}
                                    disabled={reportTile.disabled}
                                >
                                    <Text className='select-report-popover-body__tile-name' message={reportTile.label} />
                                    <Text className='select-report-popover-body__tile-description' message={reportTile.description} />
                                </button>
                            );
                        })}
                    </div>}
                    {!!postEventReports.length && <div className='flex select-report-popover-body__reports column'>
                        <Text message='Post-Event Reports' className='flex select-report-popover-body__title' />
                        {postEventReports.map(reportTile => {
                            return (
                                <button
                                    key={reportTile.label}
                                    className='flex select-report-popover-body__tile'
                                    onClick={() => tileAction(reportTile.action)}
                                    disabled={reportTile.disabled}
                                >
                                    <Text className='select-report-popover-body__tile-name' message={reportTile.label} />
                                    <Text className='select-report-popover-body__tile-description' message={reportTile.description} />
                                </button>
                            );
                        })}
                    </div>
                    }
                </div>
            </form>
        );
    });

const SelectReportPopover = injectIntl((props: ISelectReportTypeModalProps) => {
    const {
        titlePopover,
        popoverIsOpen,
        ...rest
    } = props;

    return (
        <CommonModal
            title={titlePopover}
            isOpen={popoverIsOpen}
            onRequestClose={props.closePopover}
            className='select-report-popover'
        >
            <ModalBody {...rest} />
        </CommonModal>
    );
});

export { SelectReportPopover };
